/**
 * Central registry of PostHog feature flag keys.
 * Keep keys in sync with the PostHog dashboard.
 */
export const FEATURE_FLAG_KEYS = {
  /** Toggle used to verify PostHog feature flag wiring in the app. */
  TEST_FEATURE: "testFeatureEnabled",
  /** Social network kill switch — fail closed unless VITE_SOCIAL_ENABLED=true. */
  SOCIAL: "is_social_enabled",
  /** Direct social messaging rollout switch. */
  SOCIAL_MESSAGING: "is_social_messaging_enabled",
  /** Selo de Presença (Social dynamic verification) rollout. */
  SOCIAL_DYNAMIC_VERIFICATION: "social-dynamic-verification",
  /** Facebook Login kill switch — fail closed unless VITE_FACEBOOK_LOGIN_ENABLED=true. */
  FACEBOOK_LOGIN: "is_facebook_login_enabled",
  /** Ingresso / public event ticketing kill switch — fail closed. */
  INGRESSO: "is_ingresso_enabled",
} as const;

export type FeatureFlagKey =
  (typeof FEATURE_FLAG_KEYS)[keyof typeof FEATURE_FLAG_KEYS];
